<template>
  <section
    class="OnboardingFeatureView"
  >
    <slot />
  </section>
</template>

<script lang="ts" setup>
</script>

<style lang="scss" scoped>
.OnboardingFeatureView {
  display: grid;
  gap: 32px;
  place-items: center;
  align-content: center;
  height: 100%;
  padding: 0 20px;
  overflow: hidden;

  mask-image: linear-gradient(to right, transparent, black 20px, black calc(100% - 20px), transparent);

  scroll-snap-align: center;
  scroll-snap-stop: always;

  :deep(p) {
    font-size: 20px;
    font-stretch: var(--fontWidthExtended);
    text-align: center;
    text-wrap: balance;
    line-height: 1.5;
  }
}
</style>
